"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  colors: {
    primary: ['#0A5ECC', // [0] $primary
    '#033a81', // [1] $primary-dark
    '#5193E9', // [2] $primary-mid
    '#E7F1FF'],
    secondary: ['#00264F', // [0] $secondary
    '#001A37', // [1] $secondary-dark
    '#104379', // [2] $secondary-mid
    '#DFECF9'],
    info: ['#00B7CC', // [0] $info
    '#006882', // [1] $info-dark
    '#39DAEC', // [2] $info-mid
    '#D9FBFF'],
    success: ['#20A960', // [0] $success
    '#066131', // [1] $success-dark
    '#62E49F', // [2] $success-mid
    '#D8FFEA'],
    warning: ['#FDBD00', // [0] $warning
    '#A46600', // [1] $warning-dark
    '#FFDD78', // [2] $warning-mid
    '#FFFBDF'],
    accent: ['#F85228', // [0] $accent
    '#B33906', // [1] $accent-dark
    '#F37D5F', // [2] $accent-mid
    '#FFE8E3'],
    error: ['#CE063B', // [0] $error
    '#A2002B', // [1] $error-dark
    '#E0426C', // [2] $error-mid
    '#FFE7ED'],
    white: '#ffffff',
    neutral: ['#232B34', // [0] $neutral-0 ($grey-dark) Headings, shadows, tooltips, overlays
    '#475666', // [1] $neutral-1 ($grey) Body default and small, icon hover
    '#6C7885', // [2] $neutral-2 Body meta
    '#B5BBC2', // [3] $neutral-3 ($grey-light) Placeholder text, icons
    '#DADDE0', // [4] $neutral-4 ($grey-lighter) HR, disable button, input border
    '#ECEEEF', // [5] $neutral-5 ($grey-lightest) Section Background, table header, tag
    '#F6F7F7']
  },
  spacing: ['0', // [0]
  '4', // [1]
  '8', // [2]
  '16', // [3]
  '24', // [4]
  '32', // [5]
  '40', // [6]
  '64', // [7]
  '96', // [8]
  '2'],
  zindex: ['0', // [0]
  '100', // [1]
  '200', // [2]
  '300', // [3]
  '400', // [4]
  '500'],
  fonts: {
    family: ['\'Proxima Nova\', \'Roboto\', \'Helvetica Neue\', \'Arial\', \'sans-serif\''],
    size: ['10', // [0] H6 Tablet and Mobile
    '12', // [1] H6 Desktop, H5 Tablet and Mobile
    '14', // [2] H5 Desktop, H4 Tablet and Mobile
    '16', // [3] H4 Desktop, H3 Mobile
    '18', // [4] H3 Tablet, H2 mobile
    '20', // [5] H3 Desktop, H1 Mobile
    '24', // [6] H2 Desktop, H1 Tablet
    '30'],
    lineHeight: ['1', // [0]
    '1.5', // [1]
    '2', // [2]
    '12', // [3] Tablet - H6, Body Meta;  Mobile - H6, Body Meta
    '16', // [4] Desktop - h6, Body Meta;  Tablet - H5, Body Small, Label;  Mobile: H5, Body Small, Label
    '18', // [5] Tablet - H4, Body Default;  Mobile - H4, Body Default
    '20', // [6] Desktop - H5, Body Small, Label;
    '24', // [7] Desktop - H4, Body Default;  Mobile - H3
    '26', // [8] Tablet - H3;  Mobile - H2
    '28', // [9] Desktop - H3;  Tablet - H2:  Mobile - H1
    '32', // [10] Desktop - H2;  Tablet - H1
    '40'],
    weight: ['100', // [0] Thin
    '300', // [1] Light
    '400', // [2] Normal
    '600', // [3] Semi-bold
    '700' // [4] Bold
    ]
  },
  container: {
    radius: ['0', '3', '7', '15'],
    shadow: ['0 2px 3px 0 rgba(35,43,52,0.15)', // [0] Small: advocacy tile, stage tile, typeahead, input, use with border
    '0 0 20px 0 rgba(35,43,52,0.1), 0 2px 4px 0 rgba(35,43,52,0.1)', // [1] Medium: input and card shadow
    '0 10px 30px 0 rgba(35,43,52,0.1), 0 3px 12px 0 rgba(35,43,52,0.1)', // [2] Large: card shadow
    'inset 0 2px 4px 0 rgba(35,43,52,0.2)', // [3] Inner shadow
    '0 0 30px 0 rgba(35,43,52,0.1), 0 3px 12px 0 rgba(35,43,52,0.1)', // [4] Modal and notched popover shadow
    '0 2px 6px 0 rgba(35,43,52,0.25)']
  },
  sizes: {
    desktop: 992,
    tablet: 768,
    phone: 576
  },
  defaultFocus: 'outline: 1px dotted #212121; outline: 5px auto -webkit-focus-ring-color;'
};
exports.default = _default;